// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"f1c38398","917":"a4395e64"}[chunkId] + ".chunk.js";
};